import web3 from 'web3'
// import { getUserLevel } from '@/contract/index'

const user = {
  state: {
    accountAddress: '',
    userData: {
      level: 0,
    },
  },

  getters: {
    accountAddress: (state) => state.accountAddress,
    isWalletConnected: (state) => Boolean(state.accountAddress),
  },

  mutations: {
    SET_ADDRESS: (state, address) => {
      state.accountAddress = address || ''
    },
    CLEAR_ADDRESS: (state) => {
      state.accountAddress = ''
    },
    SET_USERDATA: (state, userData) => {
      state.userData = userData
    },
  },

  actions: {
    // loadUserData({ commit, state }) {
    //   return new Promise(async (resolve, reject) => {
        
    //     resolve()
    //   })
    // },
  },
}

export default user
